<template>
    <div class="window-wrapper window-mail-subscribe-cancel">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Вы действительно хотите отменить подписку на данное сообщение? В случае, если к письму были прикреплены файлы, они будут удалены с Google Диска.</div>
                    <div class="button-block">
                        <button @click="confirmCancel" class="button button-dark button-close-window">Да</button>
                        <button @click="closeWindow" class="button button-opacity button-close-window">Отмена</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CancelSubscribeWindow",
        methods: {
            confirmCancel() {
                this.$emit('confirmCancel');
                this.closeWindow();
            },
            closeWindow() {
                $('.window-wrapper').removeClass('window-open');
                $('body').removeClass('blocked');
            }
        }
    }
</script>

<style scoped>

</style>